document.addEventListener('change', event => {
  if (!event.target.matches('[data-product-select]')) return;
  const option = event.target.selectedOptions[0];
  const id = option.value;
  const price = option.dataset.price;
  const form = event.target.closest('[data-product-form]');
  form.querySelector('[name="id"]').value = id;
  form.querySelector('[data-product-price]').textContent = price;
});
